import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ShapeCloudCalloutIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="shapeCloudCallout" ref={ref} {...props}>
    <path d="M20.76,2.41H14a.75.75,0,0,0-.75.75V9.61l-1.76,1.76a2.52,2.52,0,0,0-3.91-.45,2.53,2.53,0,0,0-4.22,1.14,2.53,2.53,0,0,0-1.13,4.22,2.46,2.46,0,0,0-.73,1.77,2.5,2.5,0,0,0,.74,1.79,2.4,2.4,0,0,0,1.12.65,2.53,2.53,0,0,0,4.22,1.14,2.53,2.53,0,0,0,4.22-1.14,2.53,2.53,0,0,0,1.86-2.44,2.46,2.46,0,0,0-.73-1.77,2.52,2.52,0,0,0-.37-3.86l1.75-1.75h6.45a.75.75,0,0,0,.75-.75V3.16A.76.76,0,0,0,20.76,2.41ZM11.23,17a1,1,0,0,1,.93,1,1,1,0,0,1-.3.73,1,1,0,0,1-.72.3.75.75,0,0,0-.53.22.71.71,0,0,0-.22.53,1,1,0,0,1-2.06.09v-.09a.75.75,0,0,0-1.5,0v.09a1,1,0,0,1-2.06-.09A.75.75,0,0,0,4,19.08a1,1,0,0,1-.09-2,.76.76,0,1,0,0-1.51,1,1,0,0,1,.09-2,.75.75,0,0,0,.75-.75,1,1,0,0,1,2.06-.09v.09a.75.75,0,0,0,1.5,0v-.09a1,1,0,0,1,2.06.09.75.75,0,0,0,.75.75,1,1,0,0,1,.09,2,.79.79,0,0,0-.84.75h0A.79.79,0,0,0,11.23,17ZM20,9.17H14.75V3.91H20Z" />
  </Icon>
)) as IconWithRender;

ShapeCloudCalloutIcon.displayName = 'ShapeCloudCalloutIcon';
ShapeCloudCalloutIcon.renderIcon = (props) => (
  <ShapeCloudCalloutIcon {...props} />
);
export default ShapeCloudCalloutIcon;
